var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-icon',{staticClass:"kt-nav__link-icon",attrs:{"type":_vm.type,"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }